<div class="" [ngClass]="{'overflow-hidden' : !!isCollapsed, 'dark-index' : !theme}" >
    <div class="vh-100">
        <router-outlet></router-outlet>
    </div>

</div>